class Orgao {
    constructor(
        {
            id = null, 
            nivel_orgao_siom = null, 
            sigla_orgao = null, 
            nome_orgao = null, 
            poder = null, 
            ind_ativo = null, 
            ind_favorito_dom = null, 
            orgao_id = null, 
            dt_desativacao = null, 
            dt_criacao = null, 
            dt_atualizacao = null,               
        } = {}
    ) {
        this.id = id; 
        this.nivel_orgao_siom = nivel_orgao_siom; 
        this.sigla_orgao = sigla_orgao; 
        this.nome_orgao = nome_orgao; 
        this.poder = poder; 
        this.ind_ativo = ind_ativo; 
        this.ind_favorito_dom = ind_favorito_dom; 
        this.orgao_id = orgao_id; 
        this.dt_desativacao = dt_desativacao; 
        this.dt_criacao = dt_criacao; 
        this.dt_atualizacao = dt_atualizacao;  
        
        this.sigla_nome_orgao = (sigla_orgao && nome_orgao) ? sigla_orgao + ' - '+ nome_orgao : null;  
    }
}

export default Orgao;